import '../styles/Welcome.css'



function Welcome() {
    return (

    <div id="welcome">


        <p>
        <span>Elliot GUIBERTEAU</span>
        </p>
  
        <p>
        <span>Technicien informatique</span>
        </p>

    

    </div>

    )
}   

export default Welcome
